module.exports = __webpack_public_path__ + "img/H2.363e60ad.png";